module.exports = __webpack_public_path__ + "img/1666234386494-Chrysanthemum.jpg.4b87042b.webp";